module.exports = __webpack_public_path__ + "img/tx.2b306c56.jpg";